<template>
  <div>
    <Modal v-model="visible" title="提现结算单" :mask-closable="false" :footer-hide="true" width="1200px" class="my-modal top">
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="lookDetail(row)">明细</span>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
    </Modal>
  </div>
</template>

<script>
import filter from '@/api/filter';
import { mapState } from 'vuex';
import { common, pageTool } from '@/api/mixins';

export default {
  mixins: [common, pageTool],
  data() {
    return {
      visible: false,
      columns: [
        {
          title: '结算周期',
          key: 'settleDate',
          align: 'center',
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            let settleDate = params.row.settleDate;
            return <span>{filter.filterTime(settleDate, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '结算单名称',
          key: 'settleName',
          align: 'center',
          minWidth: 150,
          tooltip: true
        },
        {
          title: '税前合计（元）',
          key: 'totalIncome',
          align: 'center',
          minWidth: 170,
          tooltip: true
        },
        {
          title: '税后合计（元）',
          key: 'realIncome',
          align: 'center',
          minWidth: 140,
          tooltip: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 120,
          align: 'center'
        }
      ],
      tableDate: [],
      detailColumns: []
    };
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    lookDetail(row) {
      this.visible = false;
      this.$nextTick(()=>{
        this.openPageTabTags('/financialManage/salesmanPaySettlement/detail', {
          reportId: row.reportId,
          tabVal: 1,
          userId: row.userId,
          pageType:'withdrawal'
        });
      });
    },
    open(userId, withdrawLogId) {
      this.visible = true;
      this.searchParams = {
        userId,
        withdrawLogId
      }
      this.initListAjax('/buz/baseUserSalary/read/list');
    }
  }
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ .ivu-modal-body {
    padding-top: 20px;
  }
}
</style>
